export const columns = [
  {
    title: 'Magazin',
    field: 'name',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Coeficient',
    field: 'growth',
    align: 'left',
    type: 'string'
  },

  {
    title: 'Ultima actualizare',
    field: 'username',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Ultima modificare',
    field: 'lastChange',
    align: 'left',
    type: 'date'
  }
]
